import React from 'react';
import { useIntl } from 'react-intl';
import { StyledButton } from 'styles/overrides';
import { UploadIcon } from 'assets/icons';
import { Notification } from 'components/Notification';

export const UploadTemplate = ({ mutation, title }) => {
    const intl = useIntl();
    const fileInputRef = React.useRef(null);

    const handleButtonClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files?.[0];
        if (!file || !mutation) return;

        const formData = new FormData();
        formData.append('file', file);
        // Reset input value to allow selecting the same file again if needed
        event.target.value = '';

        mutation.mutate(formData, {
            onSuccess: () => {
                Notification(
                    'success',
                    intl.formatMessage({ id: 'message.uploadSuccess' })
                );
            },
            onError: (error) => {
                Notification(
                    'error',
                    error?.message || intl.formatMessage({ id: 'message.commonError' })
                );
            },
        });
    };

    return (
        <>
            <input
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
                accept=".csv,.xlsx,.xls"
            />
            <StyledButton
                icon={<UploadIcon />}
                size="large"
                onClick={handleButtonClick}
                loading={mutation.isLoading}
            >
                {title ?? intl.formatMessage({ id: 'common.btn.downloadCsvTemplate' })}
            </StyledButton>
        </>
    );
};
